const LocalesRequestEnum = Object.freeze({
  Czech: 'cs',
  German: 'de',
  French: 'fr',
  Slovak: 'sk',
  Spanish: 'es',
})

export default LocalesRequestEnum
